// extracted by mini-css-extract-plugin
module.exports = {"container":"EventsList_container__1Vijt"};